import React, { Component } from "react";
import CeiPopup from "./base-components/CeiPopup";
import CeiTable from "./base-components/CeiTable";
import Toggle from "./base-components/Switch";
import Report from "./base-components/Report";
import FormItem from "./FormItem";
import NavigationGroup from "./NavigationGroup";
import {
  K1_RUBBER_AIR,
  K1_PHOTOVOLTAIC,
  K1_PVC_AIR,
  FLOWS_AL,
  FLOWS_CU,
  K1_RUBBER_GROUND,
  K1_PVC_GROUND,
  K2_FACTORS,
  K3_GROUND,
  K4_UNI_GROUND,
  K4_MULTI_GROUND,
  KS_2LAYERS,
  KS_3LAYERS,
  /*K, NK,*/ NORMAL_SECTIONS,
  REACTANCE_MULTI,
  REACTANCE_UNI,
  KF,
} from "./Constants";
import Info from "./base-components/Info";
import Select from "./base-components/Select";
import { jsPDF } from "jspdf";

export default class Form extends Component {
  bk = "   ";

  defaults = {
    step: 1,
    stepName: `Parametri${this.bk}Impianto`,

    // step 1
    step1: {
      nome: "",
      fotovoltaico: false,
      optionsCircuito: ["Trifase in ca", "Monofase in ca", "Continua"],
      circuito: "Trifase in ca",
      optionsStatoNeutro: ["Non distribuito", "Distribuito"],
      neutro: "Non distribuito",
      temperaturaMin: 5,
      temperaturaAmbiente: 30,
      tensioneEsercizio: 400,
      fattorePotenza: 0.8,
      fattorePotenzaDisabled: false,
      frequenzaRete: 50,
      neutroDisabled: false,
      frequenzaDisabled: false,
      tempoIntervento: 0.1,
      massimaCadutaTensione: 5,
      lunghezzaImpianto: 100,
    },

    // step 2
    step2: {
      metodo: "Potenza attiva assorbita (KW)",
      potenzaAttiva: 1,
      potenzaAttivaHidden: false,
      correnteEsercizio: Number(1.8).toFixed(3),
      correnteEsercizioDisabled: true,
      potenzaApparente: 1.25,
      potenzaApparenteHidden: true,
      reattanza: 0.75,
      tipoConduttore: "Unipolare con guaina",
      optionsPosa: [
        "Cavi in tubo incassato in parete isolante",
        "Cavi in tubo in aria",
        "Cavi in aria libera in posizione non accessibile",
        "Cavi in aria libera a trifoglio",
        "Cavi in aria libera in piano a contatto",
        "Cavi in aria libera distanziati su piano orizzontale",
        "Cavi in aria libera distanziati su piano verticale",
        "Cavi unipolari in tubi interrati a contatto",
        "Cavi unipolari in tubo interrato",
      ],
      posa: "Cavi in tubo in aria",
      ceiArgs: [
        "3A",
        "4A",
        "5A",
        "21",
        "22A",
        "25",
        "31",
        "32",
        "33A",
        "34A",
        "43",
      ],
      ceiImg: "./images/placing-schemes/15.gif",
      popupImg: "1",
      popupProps: { visibility: "hidden", opacity: 0 },
      popupText: "",
    },

    // step 3
    step3: {
      conduttoriParallelo: 1,
      circuitiStessoStrato: 1,
      stessoMaterialeIsolante: true,
      stessoMaterialeIsolanteHidden: true,
      sezioniSimili: true,
      numeroStrati: 1,
      disposizione: "Raggruppati a fascio, annegati",
      optionsDisposizione: [
        "Raggruppati a fascio, annegati",
        "Singolo strato su muro, pavimento o passerelle non perforate",
        "Strato a soffitto",
        "Strato su passerelle perforate orizzontali o verticali",
        "Strato su scala posa cavi o graffato ad un sostegno ",
      ],
      numeroCircuitiStessoFascio: 1,
      resistivitaTerreno: 1,
      profonditaPosa: [0.5, 0.6, 0.8],
      profonditaPosaHidden: [true, true],
      distanzaCircuiti: 0,
      optionsProfondita1: [0.5, 0.6, 0.8, 1, 1.2, 1.5],
      optionsProfondita2: [0.6, 0.8, 1, 1.2, 1.5],
      optionsProfondita3: [0.8, 1, 1.2, 1.5],
    },

    // step 4
    step4: {
      materialeIsolante: "Elastomerico (Gomma)",
      lsoh: false,
      tipoCavo: "FS18OR18",
      caviElastomerici: [
        "FG16R16 0.6/1 KV",
        "FG16H2R16 0.6/1 KV",
        "RG16R16 0.6/1 KV",
        "ARG16R16 0.6/1 KV",
        "H07RN-F",
      ],
      caviTermoplastici: [],
      lsohDisabled: false,
    },
  };

  state = {
    step: 1,
    stepName: `Parametri${this.bk}Impianto`,

    // step 1
    nome: "",
    fotovoltaico: false,
    optionsCircuito: ["Trifase in ca", "Monofase in ca", "Continua"],
    circuito: "Trifase in ca",
    optionsStatoNeutro: ["Non distribuito", "Distribuito"],
    neutro: "Non distribuito",
    temperaturaMin: 5,
    temperaturaAmbiente: 30,
    tensioneEsercizio: 400,
    fattorePotenza: 0.8,
    fattorePotenzaDisabled: false,
    neutroDisabled: false,
    frequenzaRete: 50,
    frequenzaDisabled: false,
    tempoIntervento: 0.1,
    massimaCadutaTensione: 5,
    lunghezzaImpianto: 100,

    // step 2
    metodo: "Potenza attiva assorbita (KW)",
    potenzaAttiva: Number(1).toFixed(3),
    potenzaAttivaHidden: false,
    correnteEsercizio: Number(1.8).toFixed(3),
    correnteEsercizioDisabled: true,
    potenzaApparente: Number(1.25).toFixed(3),
    potenzaApparenteHidden: true,
    reattanza: 0.75,
    tipoConduttore: "Unipolare con guaina",
    optionsPosa: [
      "Cavi in tubo in aria",
      "Cavi in tubo incassato in parete isolante",
      "Cavi in aria libera in posizione non accessibile",
      "Cavi in aria libera a trifoglio",
      "Cavi in aria libera in piano a contatto",
      "Cavi in aria libera distanziati su piano orizzontale",
      "Cavi in aria libera distanziati su piano verticale",
      "Cavi unipolari in tubi interrati a contatto",
      "Cavi unipolari in tubo interrato",
    ],
    posa: "Cavi in tubo in aria",
    ceiArgs: [
      "3A",
      "4A",
      "5A",
      "21",
      "22A",
      "25",
      "31",
      "32",
      "33A",
      "34A",
      "43",
    ],
    ceiImg: "./images/placing-schemes/15.gif",
    popupImg: "1",
    popupProps: { visibility: "hidden", opacity: 0 },
    popupText: "",

    // step 3
    tipoPosa: 1,
    conduttoriParallelo: 1,
    circuitiStessoStrato: 1,
    stessoMaterialeIsolante: true,
    stessoMaterialeIsolanteHidden: true,
    sezioniSimili: true,
    numeroStrati: 1,
    disposizione: "Raggruppati a fascio, annegati",
    optionsDisposizione: [
      "Raggruppati a fascio, annegati",
      "Singolo strato su muro, pavimento o passerelle non perforate",
      "Strato a soffitto",
      "Strato su passerelle perforate orizzontali o verticali",
      "Strato su scala posa cavi o graffato ad un sostegno ",
    ],
    numeroCircuitiStessoFascio: 1,
    resistivitaTerreno: 1,
    profonditaPosa: [0.5, 0.6, 0.8],
    profonditaPosaHidden: [true, true],
    distanzaCircuiti: 0,
    optionsProfondita1: [0.5, 0.6, 0.8, 1, 1.2, 1.5],
    optionsProfondita2: [0.6, 0.8, 1, 1.2, 1.5],
    optionsProfondita3: [0.8, 1, 1.2, 1.5],

    // step 4
    materialeIsolante: "Elastomerico (Gomma)",
    lsoh: false,
    tipoCavo: "FG16R16 0.6/1 KV",
    caviElastomerici: [
      "FG16R16 0.6/1 KV",
      "FG16H2R16 0.6/1 KV",
      "RG16R16 0.6/1 KV",
      "ARG16R16 0.6/1 KV",
      "H07RN-F",
    ],
    caviTermoplastici: [],
    lsohDisabled: false,

    // step 5
    report: [],
    infoProps: { visibility: "hidden", opacity: 0 },
    sezioneConduttore: 1.5,
    recalculating: false,
  };

  data = {};
  confirmShown = false;

  home = () => (window.location.href = "https://www.cablesproject.com/");
  facebook = () => window.open("https://www.facebook.com/GCcablesproject");
  youtube = () =>
    window.open("https://www.youtube.com/channel/UCilVArOZMnqV97e2o5hqveQ");

  save = () => {
    console.log("save");

    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," +
        encodeURIComponent(JSON.stringify(this.state))
    );
    element.setAttribute("download", "cp-project.json");

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };

  import = () => {
    console.log("import");

    var input = document.createElement("input");
    input.type = "file";
    input.accept = ".json, .txt";

    input.onchange = (e) => {
      var file = e.target.files[0],
        state;
      file.text().then((text) => {
        state = JSON.parse(text);
        state.step = this.state.step;
        state.stepName = this.state.stepName;
        this.setState(state);
      });
    };

    input.click();
  };
  info = () =>
    this.setState({ infoProps: { visibility: "visible", opacity: "1" } });

  // sezione calcoli
  isAluminiumCable = () => {
    return ["ARG16M16 0.6/1 KV", "ARG16R16 0.6/1 KV"].includes(
      this.state.tipoCavo
    );
  };

  // Tabella portate
  tabellaPortate = (rTabIz, cTabIz) => {
    var flows = this.isAluminiumCable() ? FLOWS_AL : FLOWS_CU;
    let val = flows[rTabIz][cTabIz];
    return val !== undefined ? val : 0;
  };

  updateTMax_kt = () => {
    var Tmf, Tmc, k;

    Tmf = 70;
    Tmc = 160;
    k = 115;

    if (
      this.state.materialeIsolante === "Elastomerico (Gomma)" &&
      this.state.stessoMaterialeIsolante
    ) {
      Tmf = 90;
      Tmc = 250;
      k = 143;
    }

    this.data.TmaxF = Tmf;
    this.data.TmaxCc = Tmc;
    this.data.kt = k;
  };

  isUnderground = () => {
    return this.getTipoPosa() === 3;
  };

  isInTubeNotUnderground = () => {
    return this.getTipoPosa() === 1;
  };

  calculateK1 = () => {
    var result, insulatingMaterial, environmentTemperature, i;

    environmentTemperature = this.state.temperaturaAmbiente;
    insulatingMaterial = this.state.materialeIsolante;

    if (!this.isUnderground()) {
      if (insulatingMaterial === "Termoplastico") {
        for (i = 0; i < 12; i++)
          if (environmentTemperature >= 10 + i * 5) result = K1_PVC_AIR[i];
      } else {
        // gomma aria
        if (this.state.fotovoltaico) {
          result = 1;
          for (i = 0; i < 7; i++)
            if (environmentTemperature >= 60 + i * 10) {
              result = K1_PHOTOVOLTAIC[i];
            }
        } else {
          for (i = 0; i < 15; i++)
            if (environmentTemperature >= 10 + i * 5) result = K1_RUBBER_AIR[i];
        }
      }
    } else {
      //isUnderground
      if (insulatingMaterial === "Termoplastico") {
        // pvc terra
        for (i = 0; i < 12; i++)
          if (environmentTemperature >= 10 + i * 5) result = K1_PVC_GROUND[i];
      } else {
        // gomma terra
        for (i = 0; i < 15; i++)
          if (environmentTemperature >= 10 + i * 5)
            result = K1_RUBBER_GROUND[i];
      }
    }

    this.data.K1 = result;
  };

  // In CP2012 i coefficienti K2 non sono corretti
  calculateK2 = () => {
    let result,
      cablesPlacing,
      conductorDistance,
      sameSection,
      inTerra,
      conductorType,
      NS,
      NCS,
      tableRow;

    cablesPlacing = this.state.disposizione;
    conductorDistance = String(
      [0.0, 0.25, 0.5, 1.0].indexOf(this.state.distanzaCircuiti)
    );
    sameSection = this.state.sezioniSimili;
    inTerra = this.isUnderground();

    conductorType = this.state.tipoConduttore;
    NS = this.state.numeroStrati;
    NCS = this.state.circuitiStessoStrato;

    if (!inTerra) {
      if (sameSection) {
        if (NS === 1) {
          tableRow = {
            "Raggruppati a fascio, annegati": 0,
            "Singolo strato su muro, pavimento o passerelle non perforate": 1,
            "Strato a soffitto": 2,
            "Strato su passerelle perforate orizzontali o verticali": 3,
            "Strato su scala posa cavi o graffato ad un sostegno": 4,
          }[cablesPlacing];
        } else {
          if (conductorType === "Multipolare") {
            if (NS === 2) {
              tableRow = {
                "Passerelle orizzontali perforate - Cavi contigui": 5,
                "Passerelle orizzontali perforate - Cavi spaziati": 7,
                "Passerelle verticali perforate - Cavi contigui": 9,
                "Scala posa cavi o elemento di sostegno - Cavi contigui": 11,
                "Scala posa cavi o elemento di sostegno - Cavi spaziati": 13,
              }[cablesPlacing];
            } else {
              tableRow = {
                "Passerelle orizzontali perforate - Cavi contigui": 6,
                "Passerelle orizzontali perforate - Cavi spaziati": 8,
                "Passerelle verticali perforate - Cavi contigui": 10,
                "Scala posa cavi o elemento di sostegno - Cavi contigui": 12,
                "Scala posa cavi o elemento di sostegno - Cavi spaziati": 14,
              }[cablesPlacing];
            }
          } else {
            if (NS === 2) {
              tableRow = {
                "Passerelle orizzontali perforate - cavi in formazione orizzontale": 15,
                "Passerelle verticali perforate - cavi in formazione verticale": 17,
                "Scala posa cavi o elemento di sostegno - cavi in formazione orizzontale": 18,
                "Passerelle orizzontali perforate - cavi in formazione a trefolo": 20,
                "Passerelle verticali perforate - cavi in formazione a trefolo": 22,
                "Scala posa cavi o elemento di sostegno - cavi in formazione a trefolo": 23,
              }[cablesPlacing];
            } else {
              tableRow = {
                "Passerelle orizzontali perforate - cavi in formazione orizzontale": 16,
                "Passerelle verticali perforate - cavi in formazione verticale": 17,
                "Scala posa cavi o elemento di sostegno - cavi in formazione orizzontale": 19,
                "Passerelle orizzontali perforate - cavi in formazione a trefolo": 21,
                "Passerelle verticali perforate - cavi in formazione a trefolo": 22,
                "Scala posa cavi o elemento di sostegno - cavi in formazione a trefolo": 24,
              }[cablesPlacing];
            }
          }
        }
        result = K2_FACTORS[tableRow][NCS - 1];
      } else {
        result = Math.pow(1 / NCS, 0.5);
      }
    } else {
      if (conductorType === "Multipolare") {
        tableRow = {
          0: 25,
          1: 26,
          2: 27,
          3: 28,
        }[conductorDistance];
      } else {
        tableRow = {
          0: 29,
          1: 30,
          2: 31,
          3: 32,
        }[conductorDistance];
      }

      result = K2_FACTORS[tableRow][NCS - 1];
    }

    this.data.K2 = result;
  };

  calculateK3 = (pp, i) => {
    var result, k3_index;

    result = 1;
    k3_index = 0;

    switch (pp) {
      case 0.5:
        k3_index = 0;
        break;
      case 0.6:
        k3_index = 1;
        break;
      case 0.8:
        k3_index = 2;
        break;
      case 1.0:
        k3_index = 3;
        break;
      case 1.2:
        k3_index = 4;
        break;
      case 1.5:
        k3_index = 5;
        break;
      default:
        k3_index = 0;
    }

    result = K3_GROUND[k3_index];

    if (this.data.K3 === undefined) this.data.K3 = [];

    this.data.K3[i] = result;
  };

  calculateK4 = (i) => {
    var result, conductorType, soilThermalResistivity, roIndex;

    conductorType = this.state.tipoConduttore;
    soilThermalResistivity = this.state.resistivitaTerreno;
    roIndex = ["1.0", "1.2", "1.5", "2.0", "2.5"].indexOf(
      Number(soilThermalResistivity).toFixed(1)
    );

    if (conductorType === "Multipolare") {
      result = K4_MULTI_GROUND[roIndex];
    } else {
      result = K4_UNI_GROUND[roIndex];
    }

    if (this.data.K4 === undefined) this.data.K4 = [];

    this.data.K4[i] = result;
  };

  findRowInFlows = () => {
    var result,
      isMonophase,
      circuitType,
      setPVC,
      insulatingMaterial,
      sameInsulating,
      conductorType,
      placing;

    circuitType = this.state.circuito;
    insulatingMaterial = this.state.materialeIsolante;
    sameInsulating = this.state.stessoMaterialeIsolante;
    conductorType = this.state.tipoConduttore;
    placing = this.state.posa;

    if (this.state.fotovoltaico) {
      result = 50;
    } else {
      isMonophase = !(circuitType === "Trifase in ca");
      setPVC = insulatingMaterial === "Termoplastico" || !sameInsulating;

      if (!this.isUnderground()) {
        if (conductorType === "Multipolare") {
          switch (placing) {
            case "Cavi in tubo incassato in parete isolante":
              if (setPVC) {
                if (isMonophase) {
                  result = 0;
                } else {
                  result = 1;
                }
              } else {
                if (isMonophase) {
                  result = 2;
                } else {
                  result = 3;
                }
              }
              break;
            case "Cavi in tubo in aria":
              if (setPVC) {
                if (isMonophase) {
                  result = 4;
                } else {
                  result = 5;
                }
              } else {
                if (isMonophase) {
                  result = 6;
                } else {
                  result = 7;
                }
              }
              break;
            case "Cavi in aria libera distanziati dalla parete/soffitto o su passerella":
              if (setPVC) {
                if (isMonophase) {
                  result = 8;
                } else {
                  result = 9;
                }
              } else {
                if (isMonophase) {
                  result = 10;
                } else {
                  result = 11;
                }
              }
              break;
            case "Cavi in aria libera fissati alla parete/soffitto":
              if (setPVC) {
                if (isMonophase) {
                  result = 12;
                } else {
                  result = 13;
                }
              } else {
                if (isMonophase) {
                  result = 14;
                } else {
                  result = 15;
                }
              }
              break;
            default:
              break;
          }
        } else {
          // not Multipolare
          switch (placing) {
            case "Cavi in aria libera a trifoglio":
              if (setPVC) {
                result = 16;
              } else {
                result = 17;
              }
              break;
            case "Cavi in aria libera in piano a contatto":
              if (setPVC) {
                if (isMonophase) {
                  result = 18;
                } else {
                  result = 19;
                }
              } else {
                if (isMonophase) {
                  result = 20;
                } else {
                  result = 21;
                }
              }
              break;
            case "Cavi in aria libera distanziati su piano orizzontale":
              if (setPVC) {
                result = 22;
              } else {
                result = 23;
              }
              break;
            case "Cavi in aria libera distanziati su piano verticale":
              if (setPVC) {
                result = 24;
              } else {
                result = 25;
              }
              break;
            case "Cavi in tubo incassato in parete isolante":
              if (setPVC) {
                if (isMonophase) {
                  result = 26;
                } else {
                  result = 27;
                }
              } else {
                if (isMonophase) {
                  result = 28;
                } else {
                  result = 29;
                }
              }
              break;
            case "Cavi in tubo in aria":
              if (setPVC) {
                if (isMonophase) {
                  result = 30;
                } else {
                  result = 31;
                }
              } else {
                if (isMonophase) {
                  result = 32;
                } else {
                  result = 33;
                }
              }
              break;
            case "Cavi in aria libera in posizione non accessibile":
              if (setPVC) {
                if (isMonophase) {
                  result = 34;
                } else {
                  result = 35;
                }
              } else {
                if (isMonophase) {
                  result = 36;
                } else {
                  result = 37;
                }
              }
              break;
            default:
              break;
          }
        }
      } else {
        //in terra
        switch (placing) {
          case "Cavi unipolari in tubi interrati a contatto":
            if (setPVC) {
              if (isMonophase) {
                result = 38;
              } else {
                result = 39;
              }
            } else {
              if (isMonophase) {
                result = 40;
              } else {
                result = 41;
              }
            }
            break;
          case "Cavi unipolari in tubo interrato":
            if (setPVC) {
              if (isMonophase) {
                result = 42;
              } else {
                result = 43;
              }
            } else {
              if (isMonophase) {
                result = 44;
              } else {
                result = 45;
              }
            }
            break;
          case "Cavi multipolari in tubo interrato":
            if (setPVC) {
              if (isMonophase) {
                result = 46;
              } else {
                result = 47;
              }
            } else {
              if (isMonophase) {
                result = 48;
              } else {
                result = 49;
              }
            }
            break;
          default:
            break;
        }
      }
    }

    this.data.rTabIz = result;
  };

  calculate = () => {
    var NCF, NS, Ks, k, kf, pp, Ib, NCP, s, rTabIz, cTabIzNow, MDVP, i;

    this.data.dimOk = true;

    this.calculateK1();
    this.calculateK2();

    var { K1, K2 } = this.data;

    NCF = this.state.numeroCircuitiStessoFascio;
    this.data.kf = KF[NCF - 1];
    NS = this.state.numeroStrati;
    Ks = [];
    pp = this.state.profonditaPosa;
    k = [];

    if (this.isUnderground()) {
      for (i = 0; i < NS; i++) {
        switch (NS) {
          case 1:
            Ks[i] = 1;
            break;
          case 2:
            Ks[i] = KS_2LAYERS[i];
            break;
          case 3:
            Ks[i] = KS_3LAYERS[i];
            break;
          default:
            break;
        }
        this.calculateK3(pp[i], i);
        this.calculateK4(i);
        let { K3, K4 } = this.data;
        kf = this.data.kf;
        k[i] = K1 * K2 * K3[i] * K4[i] * kf * Ks[i];
        if (k[i] === 0) k[i] = 1;
      }

      this.data.Ks = Ks;
    } else {
      k[0] = K1 * K2;
      if (k[0] === 0) {
        k[0] = 1;
      }
      for (i = 1; i < NS; i++) {
        k[i] = k[0];
      }
    }
    s = 0;
    this.data.normalizedSection = s;
    this.findRowInFlows();

    Ib = parseFloat(this.state.correnteEsercizio);
    NCP = this.state.conduttoriParallelo;
    rTabIz = this.data.rTabIz;

    cTabIzNow = 16;

    for (var col = 15; col >= 0; col--)
      if (this.tabellaPortate(rTabIz, col) > 0) {
        if (Ib / NCP < this.tabellaPortate(rTabIz, col) * k[0]) {
          cTabIzNow = col;
          this.data.cTabIzNow = cTabIzNow;
        } else break;
      }

    this.data.k = k;

    if (cTabIzNow < 16) {
      s = NORMAL_SECTIONS[cTabIzNow];
      this.data.normalizedSection = s;
      this.data.minimumSection = s;
      this.data.Sc = s;
      this.calculateResults();
      MDVP = this.state.massimaCadutaTensione;

      while (this.data.DTPTf[0] > MDVP && cTabIzNow <= 16) {
        cTabIzNow += 1;
        this.data.cTabIzNow = cTabIzNow;
        s = 0;
        if (cTabIzNow < 16) {
          if (this.tabellaPortate(rTabIz, cTabIzNow) === 0) {
            cTabIzNow = 17;
            this.data.cTabIzNow = cTabIzNow;
            break;
          }

          s = NORMAL_SECTIONS[cTabIzNow];
          this.data.normalizedSection = s;
          this.data.minimumSection = s;
          this.calculateResults();
        } else {
          cTabIzNow = 17;
          this.data.cTabIzNow = cTabIzNow;
        }

        s = this.data.normalizedSection;
        this.data.minimumSection = s;

        this.data.Sc = s;
      }
    }

    //Se ho problemi con la caduta percentuale allora cTabIzNow = 17
    if (cTabIzNow === 17 || cTabIzNow === 16) this.data.dimOk = false;

    if (!this.data.dimOk) this.data.X20 = 0;

    this.data.cTabIzMin = cTabIzNow;
  };

  recalculate = () => {
    this.data.normalizedSection = this.state.sezioneConduttore;
    var i;

    for (i = this.data.cTabIzMin; i <= 15; i++) {
      if (NORMAL_SECTIONS[i] === this.data.normalizedSection) {
        this.data.cTabIzNow = i;
        this.calculateResults();

        if (this.state.tipoConduttore === "Multipolare")
          this.data.X20 =
            (REACTANCE_MULTI[this.data.cTabIzNow] *
              this.state.lunghezzaImpianto) /
            this.state.conduttoriParallelo;
        else
          this.data.X20 =
            (REACTANCE_UNI[this.data.cTabIzNow] *
              this.state.lunghezzaImpianto) /
            this.state.conduttoriParallelo;
      }
    }
  };

  calculateResults = () => {
    let ro0,
      R20,
      l,
      NCP,
      s,
      TmaxF,
      RTmaxf,
      senFi,
      cosFi,
      circuitType,
      conductorType,
      cTabIzNow,
      NS,
      rTabIz,
      Ib,
      Iz,
      k,
      Tf,
      RTf,
      kt,
      I2t,
      tIP,
      IccMax,
      i,
      Ta,
      di,
      di1,
      X20,
      Vn,
      DTPTf,
      DPPTf;

    // Impostazione resistività del rame a 20°C
    ro0 = this.isAluminiumCable() ? 0.028 : 0.017;
    this.data.ro0 = ro0;
    l = this.state.lunghezzaImpianto;
    NCP = this.state.conduttoriParallelo;
    s = this.data.normalizedSection;

    // Calcolo resistenza a 20°C
    R20 = ((ro0 * l) / (s * NCP)) * 1000;
    this.data.R20 = R20;

    // Calcolo resistenza a Tmaxf
    TmaxF = this.data.TmaxF;
    RTmaxf = R20 * (1 + 0.004 * (TmaxF - 20));
    this.data.RTmaxf = RTmaxf;
    cosFi = this.state.fattorePotenza;
    senFi = Math.pow(1 - Math.pow(cosFi, 2), 0.5);
    circuitType = this.state.circuito;
    if (circuitType === "Trifase in ca") {
      this.data.di = Math.pow(3, 0.5);
      this.data.di1 = 3;
    } else {
      this.data.di = 2;
      this.data.di1 = 2;
    }

    conductorType = this.state.tipoConduttore;
    cTabIzNow = this.data.cTabIzNow;
    if (conductorType === "Multipolare") {
      this.data.X20 = (REACTANCE_MULTI[cTabIzNow] * l) / NCP;
    } else {
      this.data.X20 = (REACTANCE_UNI[cTabIzNow] * l) / NCP;
    }

    NS = this.state.numeroStrati;
    Tf = [];
    RTf = [];
    DTPTf = [];
    DPPTf = [];
    Iz = [];

    for (i = 0; i < NS; i++) {
      // Calcolo della portata (NCP conduttori in parallelo)

      k = this.data.k;
      rTabIz = this.data.rTabIz;
      Iz[i] = NCP * k[i] * this.tabellaPortate(rTabIz, cTabIzNow);

      // Calcolo della temperatura di funzionamento
      Ib = this.state.correnteEsercizio;
      Ta = this.state.temperaturaAmbiente;
      Tf[i] = (TmaxF - Ta) * Math.pow(Ib / Iz[i], 2) + Ta;

      // Calcolo resistenza a Tf
      RTf[i] = R20 * (1 + 0.004 * (Tf[i] - 20));

      // Calcolo caduta di tensione percentuale
      Vn = this.state.tensioneEsercizio;
      di = this.data.di;
      di1 = this.data.di1;
      X20 = this.data.X20;

      DTPTf[i] = (di * Ib * (RTf[i] * cosFi + X20 * senFi)) / (10 * Vn);

      // Calcolo potenza dissipata percentuale
      DPPTf[i] = Math.pow((di1 * RTf[i] * Math.pow(Ib, 2)) / 10, 6);
    }

    this.data.Tf = Tf;
    this.data.RTf = RTf;
    this.data.DTPTf = DTPTf;
    this.data.DPPTf = DPPTf;
    this.data.Iz = Iz;

    // Calcolo energia specifica passante
    kt = this.data.kt;
    I2t = Math.pow(kt * s, 2) / Math.pow(10, 6);
    this.data.I2t = I2t;

    // Calcolo corrente massima di corto circuito
    tIP = this.state.tempoIntervento;
    IccMax = (kt * s) / (1000 * Math.pow(tIP, 0.5));
    this.data.IccMax = IccMax;
  };

  getReportStrati = () => {
    let result = [];

    if (!this.data.dimOk) return result;

    if (this.isUnderground()) {
      result.push(
        { label: "space" },
        { label: "Strato 1" },
        {
          label: "Profondità della posa",
          value: this.state.profonditaPosa[0].toLocaleString("it-IT", {
            minimumFractionDigits: 1,
          }),
        },
        {
          label: "Fattore di correzione K3",
          value: this.data.K3[0].toLocaleString("it-IT", {
            minimumFractionDigits: 2,
          }),
        },
        {
          label: "Fattore di correzione K4",
          value: this.data.K4[0].toLocaleString("it-IT", {
            minimumFractionDigits: 2,
          }),
        },
        // { label: "Fattore di correzione Ks", value: this.data.Ks[0].toLocaleString("it-IT", { minimumFractionDigits: 2 }) },
        {
          label: "Fattore di correzione totale",
          value: this.data.k[0].toLocaleString("it-IT", {
            minimumFractionDigits: 3,
          }),
        },
        {
          label: "Portata conduttore/i (Iz)",
          value:
            this.data.Iz[0].toLocaleString("it-IT", {
              minimumFractionDigits: 3,
            }) + " A",
        },
        {
          label: "Temperatura di funzionamento",
          value:
            this.data.Tf[0].toLocaleString("it-IT", {
              minimumFractionDigits: 3,
            }) + "°C",
        },
        {
          label: "Caduta di tensione perc. T=Tf",
          value:
            this.data.DTPTf[0].toLocaleString("it-IT", {
              minimumFractionDigits: 3,
            }) + "%",
        }
      );

      if (this.state.numeroStrati > 1) {
        result.push(
          { label: "space" },
          { label: "Strato 2" },
          {
            label: "Profondità della posa",
            value: this.state.profonditaPosa[1].toLocaleString("it-IT", {
              minimumFractionDigits: 1,
            }),
          },
          {
            label: "Fattore di correzione K3",
            value: this.data.K3[1].toLocaleString("it-IT", {
              minimumFractionDigits: 2,
            }),
          },
          {
            label: "Fattore di correzione K4",
            value: this.data.K4[1].toLocaleString("it-IT", {
              minimumFractionDigits: 2,
            }),
          },
          // { label: "Fattore di correzione Ks", value: this.data.Ks[1].toLocaleString("it-IT", { minimumFractionDigits: 2 }) },
          {
            label: "Fattore di correzione totale",
            value: this.data.k[1].toLocaleString("it-IT", {
              minimumFractionDigits: 3,
            }),
          },
          {
            label: "Portata conduttore/i (Iz)",
            value:
              this.data.Iz[1].toLocaleString("it-IT", {
                minimumFractionDigits: 3,
              }) + " A",
          },
          {
            label: "Temperatura di funzionamento",
            value:
              this.data.Tf[1].toLocaleString("it-IT", {
                minimumFractionDigits: 3,
              }) + "°C",
          },
          {
            label: "Caduta di tensione perc. T=Tf",
            value:
              this.data.DTPTf[1].toLocaleString("it-IT", {
                minimumFractionDigits: 2,
              }) + "%",
          }
        );
      }

      if (this.state.numeroStrati > 2) {
        result.push(
          { label: "space" },
          { label: "Strato 3" },
          {
            label: "Profondità della posa",
            value: this.state.profonditaPosa[2].toLocaleString("it-IT", {
              minimumFractionDigits: 1,
            }),
          },
          {
            label: "Fattore di correzione K3",
            value: this.data.K3[2].toLocaleString("it-IT", {
              minimumFractionDigits: 2,
            }),
          },
          {
            label: "Fattore di correzione K4",
            value: this.data.K4[2].toLocaleString("it-IT", {
              minimumFractionDigits: 2,
            }),
          },
          // { label: "Fattore di correzione Ks", value: this.data.Ks[2].toLocaleString("it-IT", { minimumFractionDigits: 2 }) },
          {
            label: "Fattore di correzione totale",
            value: this.data.k[2].toLocaleString("it-IT", {
              minimumFractionDigits: 3,
            }),
          },
          {
            label: "Portata conduttore/i (Iz)",
            value:
              this.data.Iz[2].toLocaleString("it-IT", {
                minimumFractionDigits: 3,
              }) + " A",
          },
          {
            label: "Temperatura di funzionamento",
            value:
              this.data.Tf[2].toLocaleString("it-IT", {
                minimumFractionDigits: 3,
              }) + "°C",
          },
          {
            label: "Caduta di tensione perc. T=Tf",
            value:
              this.data.DTPTf[2].toLocaleString("it-IT", {
                minimumFractionDigits: 2,
              }) + "%",
          }
        );
      }
    } else {
      result.push(
        {
          label: "Fattore di correzione totale",
          value: this.data.k[0].toLocaleString("it-IT", {
            minimumFractionDigits: 3,
          }),
        },
        {
          label: "Portata conduttore/i (Iz)",
          value:
            this.data.Iz[0].toLocaleString("it-IT", {
              minimumFractionDigits: 3,
            }) + " A",
        },
        {
          label: "Temperatura di funzionamento",
          value:
            this.data.Tf[0].toLocaleString("it-IT", {
              minimumFractionDigits: 3,
            }) + "°C",
        },
        {
          label: "Caduta di tensione perc. T=Tf",
          value:
            this.data.DTPTf[0].toLocaleString("it-IT", {
              minimumFractionDigits: 2,
            }) + "%",
        }
      );
    }

    return result;
  };

  // restituisce l'array contenente gli oggetti da passare a Report
  calcReport = (sezione) => {
    if (sezione === 1.5) this.calculate();
    else this.recalculate();

    if (
      (this.data.normalizedSection === 0 ||
        this.tabellaPortate(this.data.rTabIz, this.data.cTabIzNow) === 0) &&
      !this.confirmShown
    ) {
      this.confirmShown = true;
      window.confirm(
        "Impossibile calcolare la sezione: immettere più cavi in parallelo."
      );

      this.changeStep(3);
      this.forceUpdate(() => {
        this.confirmShown = false;
      });
      return null;
    }

    this.updateTMax_kt();

    let report = [
      { label: "Nome impianto", value: this.state.nome },
      {
        label: "Tipo di circuito",
        value:
          this.state.circuito +
          (this.state.fotovoltaico ? " - Impianto Fotovoltaico" : ""),
      },
      {
        label: "Tensione di esercizio",
        value: this.state.tensioneEsercizio + " V",
      },
      {
        label: "Frequenza di rete",
        value: this.state.frequenzaDisabled
          ? null
          : this.state.frequenzaRete + " Hz",
      },
      {
        label: "Fattore di potenza",
        value: this.state.fattorePotenza.toLocaleString("it-IT", {
          minimumFractionDigits: 1,
        }),
      },
      {
        label: "Stato del neutro",
        value: this.state.neutroDisabled ? null : this.state.neutro,
      },
      {
        label: "Massima caduta di tensione",
        value: this.state.massimaCadutaTensione + "%",
      },
      { label: "Tipo di conduttore", value: this.state.tipoConduttore },
      {
        label: "Tipo di cavo selezionato",
        value: "General Cavi - " + this.state.tipoCavo,
      },
      { label: "Lunghezza cavo", value: this.state.lunghezzaImpianto + " m" },
      {
        label: "Temperatura ambiente",
        value: this.state.temperaturaAmbiente + "°C",
      },
      { label: "Tipo di posa", value: this.state.posa },
      {
        label: "Disposizione",
        value: this.state.tipoPosa === 2 ? this.state.disposizione : null,
      },
      {
        label: "Resistività termica del terreno",
        value: this.isUnderground ? this.state.resistivitaTerreno : null,
      },
      {
        label: "Distanza tra i circuiti",
        value: this.state.isUnderground ? this.state.distanzaCircuiti : null,
      },

      {
        label: "Numero conduttori in parallelo",
        value: this.state.conduttoriParallelo,
      },
      {
        label: "Numero di circuiti per strato",
        value: this.state.circuitiStessoStrato,
      },
      {
        label: "Numero di strati",
        value: this.state.tipoPosa !== 1 ? this.state.numeroStrati : null,
      },
      {
        label: "Tempo di intervento delle protezioni",
        value:
          this.state.tempoIntervento.toLocaleString("it-IT", {
            minimumFractionDigits: 1,
          }) + " s",
      },
      {
        label: "Sezione conduttore (S)",
        value: this.data.normalizedSection.toLocaleString("it-IT") + " mm²",
      },
      {
        label: "Portata conduttore (*)",
        value:
          this.tabellaPortate(this.data.rTabIz, this.data.cTabIzNow) + " A",
      },
      {
        label: "Fattore di correzione k1",
        value: this.data.K1.toLocaleString("it-IT", {
          minimumFractionDigits: 3,
        }),
      },
      {
        label: "Fattore di correzione k2",
        value: this.data.K2.toLocaleString("it-IT", {
          minimumFractionDigits: 3,
        }),
      },
      {
        label: "Fattore di correzione kf",
        value: this.isUnderground() ? this.data.kf : null,
      },
      ...this.getReportStrati(),
      { label: "space" },
      {
        label: "Corrente di impiego (Ib)",
        value:
          Number(this.state.correnteEsercizio).toLocaleString("it-IT", {
            minimumFractionDigits: 3,
          }) + " A",
      },
      {
        label: "Potenza attiva (P)",
        value:
          Number(this.state.potenzaAttiva).toLocaleString("it-IT", {
            minimumFractionDigits: 3,
          }) + " KW",
      },
      {
        label: "Potenza reattiva (Q)",
        value:
          this.state.circuito !== "Continua"
            ? this.state.reattanza.toLocaleString("it-IT", {
                minimumFractionDigits: 3,
              }) + " KVAR"
            : null,
      },
      {
        label: "Potenza apparente (A)",
        value:
          this.state.circuito !== "Continua"
            ? Number(this.state.potenzaApparente).toLocaleString("it-IT", {
                minimumFractionDigits: 3,
              }) + " KVA"
            : null,
      },
      {
        label: "Temperatura Max di funzionamento",
        value:
          this.data.TmaxF.toLocaleString("it-IT", {
            minimumFractionDigits: 1,
          }) + "°C",
      },
      {
        label: "Temperatura Max di cortocircuito",
        value:
          this.data.TmaxCc.toLocaleString("it-IT", {
            minimumFractionDigits: 1,
          }) + "°C",
      },
      {
        label: "Resistenza di fase a 20 °C",
        value:
          this.data.R20.toLocaleString("it-IT", { minimumFractionDigits: 3 }) +
          " mΩ",
      },
      {
        label: "Reattanza di fase a 20 °C",
        value:
          this.data.X20.toLocaleString("it-IT", { minimumFractionDigits: 3 }) +
          " mΩ",
      },
      {
        label: "Energia specifica passante (I²t)",
        value:
          this.data.I2t.toLocaleString("it-IT", { minimumFractionDigits: 3 }) +
          " (KA)²s",
      },
      {
        label: "Corrente massima di cc",
        value:
          this.data.IccMax.toLocaleString("it-IT", {
            minimumFractionDigits: 3,
          }) + " KA",
      },
      { label: "space" },
      { label: "space" },
      { label: "(*) Riferimento Tabella UNEL 35024 o costruttore " },
    ];

    return report;
  };

  getReportPDF = () => {
    let report = this.calcReport(this.state.sezioneConduttore);
    let tabs = [18, 100, 105],
      rowPx = 30; /*, colPx = 0*/

    let doc = new jsPDF("portrait", "mm", "a4"); // 210x297
    doc.setProperties({
      title: "Cables Project: " + this.state.nome,
      subject: "Cables Project - Risultati del dimensionamento",
      keywords: "progetto, dimensionamento, cavi, general cavi",
      creator: "EIDOS Srl",
    });

    // titolo
    doc.setFontSize(22);
    doc.text(tabs[0], 20, "Progetto");

    // header
    doc.setFontSize(14);
    doc.text(tabs[0], 30, "Risultati del dimensionamento");

    // content
    doc.setFontSize(10);
    doc.setFont("courier");

    let isReportStrati = false;
    let strato = -1;
    let yStrati = 0;

    report.forEach((element) => {
      if (element.value === null) return;

      rowPx += 5;

      if (element.label === "space") return;

      let isStrato = element.label.includes("Strato");

      if (isStrato) {
        if (!isReportStrati) {
          isReportStrati = true;
          yStrati = rowPx;
        } else rowPx = yStrati;

        strato++;
      } else if (element.label.includes("impiego")) isReportStrati = false;

      doc.setFont("courier", "bold");
      if (isStrato || !isReportStrati || strato === 0)
        doc.text(
          isStrato ? tabs[2] + 30 * strato : tabs[0],
          rowPx,
          element.label + (element.label.includes("Tabella") ? "" : ":")
        );

      if (element.value === undefined) return;

      doc.setFont("courier", "normal");

      let value = String(element.value).replace("Ω", "Ohm");
      if (value.length < 45) {
        if (!isReportStrati) doc.text(tabs[2], rowPx, value);
        else doc.text(tabs[2] + 30 * strato, rowPx, value);
      } else {
        let words = value.split(" ");
        let lines = ["", ""];
        let isFull = false;

        for (let word of words) {
          if (!isFull)
            if (lines[0].length + word.length < 45)
              lines[0] += (lines[0].length > 0 ? " " : "") + word;
            else {
              isFull = true;
              lines[1] = word;
            }
          else lines[1] += " " + word;
        }

        doc.text(tabs[2], rowPx, lines[0]);
        rowPx += 5;
        doc.text(tabs[2], rowPx, lines[1]);
      }
    });

    doc.setFontSize(9);
    doc.setFont("helvetica", "italic");
    doc.text(
      tabs[1],
      280,
      "Report generato da Cables Project 2022 distribuito da General Cavi Spa."
    );

    return doc;
  };

  resetDefaults = (step) => {
    console.log(step);
    if (
      step ||
      window.confirm(
        "Vuoi procedere con un nuovo progetto?\nLa configurazione attuale verrà persa"
      )
    ) {
      switch (step) {
        case 1:
          this.setState(this.defaults.step1);
          break;
        case 2:
          this.setState(this.defaults.step2, () => {
            this.onFotovoltaicoChange(this.state.fotovoltaico);
          });
          break;
        case 3:
          this.setState(this.defaults.step3, () => {
            this.checkProfonditaPosaHidden(
              String(this.defaults.step3.numeroStrati)
            );
            this.onNumeroStratiChange();
          });
          break;
        case 4:
          this.setState(this.defaults.step4);
          break;
        default:
          this.changeStep(1);
          let def = {
            ...this.defaults.step1,
            ...this.defaults.step2,
            ...this.defaults.step3,
            ...this.defaults.step4,
          };
          this.setState(def);
      }
    }
  };

  getCeiImg = (img) => {
    return "./images/placing-schemes/" + img + ".gif";
  };

  onFotovoltaicoChange = (checked) => {
    let options = checked
      ? ["Continua"]
      : ["Trifase in ca", "Monofase in ca", "Continua"];
    let massimaCadutaTensione = checked ? 2 : 5;

    if (checked) {
      let optionsPosa = [
        "Cavi in aria libera a trifoglio",
        "Cavi in aria libera in piano a contatto",
      ];
      let tipoConduttore = "Unipolare con guaina";
      this.setState({
        optionsPosa,
        posa: optionsPosa[0],
        tipoConduttore,
        lsoh: true,
      });
    }

    let temperaturaMin = checked ? 60 : 5;

    this.setState(
      {
        fotovoltaico: checked,
        optionsCircuito: options,
        temperaturaMin,
        temperaturaAmbiente: Math.max(
          this.state.temperaturaAmbiente,
          temperaturaMin
        ),
        circuito: options[0],
        massimaCadutaTensione,
        lunghezzaImpianto: checked ? 10 : 100,
      },
      () => {
        this.onCircuitoChange();
        this.setCei();
        if (!checked) this.onTipoConduttoreChange();
      }
    );
  };

  onCircuitoChange = () => {
    let selection = this.state.circuito;

    let tensione, fattorePotenza;
    switch (selection) {
      case "Trifase in ca":
        tensione = 400;
        fattorePotenza = 0.8;
        break;
      case "Monofase in ca":
        tensione = 230;
        fattorePotenza = 0.9;
        break;
      default:
        tensione = 110;
        fattorePotenza = 1.0;
    }

    if (this.state.fotovoltaico) tensione = 400;

    this.setState(
      {
        tensioneEsercizio: tensione,
        fattorePotenza,
      },
      this.checkEnabled
    );
  };

  checkEnabled = () => {
    this.setState({
      fattorePotenzaDisabled: this.state.circuito === "Continua",
      neutroDisabled: this.state.circuito !== "Trifase in ca",
      frequenzaDisabled: this.state.circuito === "Continua",
    });
  };

  onMetodoChange = () => {
    let metodo = this.state.metodo;
    let potenzaAttivaHidden = metodo !== "Potenza attiva assorbita (KW)";
    let correnteEsercizioDisabled = metodo !== "Immissione diretta di Ib (A)";
    let potenzaApparenteHidden = metodo !== "Potenza apparente assorbita (KVA)";

    this.setState(
      {
        potenzaAttivaHidden,
        correnteEsercizioDisabled,
        potenzaApparenteHidden,
      },
      this.getIb
    );
  };

  onTipoConduttoreChange = () => {
    let optionsPosa,
      posa = this.state.posa;
    switch (this.state.tipoConduttore) {
      case "Unipolare con guaina":
        optionsPosa = [
          "Cavi in tubo incassato in parete isolante",
          "Cavi in tubo in aria",
          "Cavi in aria libera in posizione non accessibile",
          "Cavi in aria libera a trifoglio",
          "Cavi in aria libera in piano a contatto",
          "Cavi in aria libera distanziati su piano orizzontale",
          "Cavi in aria libera distanziati su piano verticale",
          "Cavi unipolari in tubi interrati a contatto",
          "Cavi unipolari in tubo interrato",
        ];
        break;
      case "Unipolare senza guaina":
        optionsPosa = [
          "Cavi in tubo incassato in parete isolante",
          "Cavi in tubo in aria",
          "Cavi in aria libera in posizione non accessibile",
        ];
        break;
      default:
        optionsPosa = [
          "Cavi in tubo incassato in parete isolante",
          "Cavi in tubo in aria",
          "Cavi in aria libera distanziati dalla parete/soffitto o su passerella",
          "Cavi in aria libera fissati alla parete/soffitto",
          "Cavi multipolari in tubo interrato",
        ];
    }

    if (!optionsPosa.includes(posa)) posa = optionsPosa[0];
    else if (!this.state.fotovoltaico) posa = "Cavi in tubo in aria";

    this.setState(
      {
        optionsPosa,
        posa,
      },
      this.setCei
    );
  };

  onNumeroStratiChange = () => {
    let optionsDisposizione;
    if (parseInt(this.state.numeroStrati) === 1)
      optionsDisposizione = [
        "Raggruppati a fascio, annegati",
        "Singolo strato su muro, pavimento o passerelle non perforate",
        "Strato a soffitto",
        "Strato su passerelle perforate orizzontali o verticali",
        "Strato su scala posa cavi o graffato ad un sostegno ",
      ];
    else if (this.state.tipoConduttore === "Multipolare")
      optionsDisposizione = [
        "Passerelle orizzontali perforate - Cavi contigui",
        "Passerelle orizzontali perforate - Cavi spaziati",
        "Passerelle verticali perforate - Cavi contigui",
        "Scala posa cavi o elemento di sostegno - Cavi contigui",
        "Scala posa cavi o elemento di sostegno - Cavi spaziati",
      ];
    else
      optionsDisposizione = [
        "Passerelle orizzontali perforate - cavi in formazione orizzontale",
        "Passerelle verticali perforate - cavi in formazione verticale",
        "Scala posa cavi o elemento di sostegno - cavi in formazione orizzontale",
        "Passerelle orizzontali perforate - cavi in formazione a trefolo",
        "Passerelle verticali perforate - cavi in formazione a trefolo",
        "Scala posa cavi o elemento di sostegno - cavi in formazione a trefolo",
      ];

    this.setState({
      optionsDisposizione,
      disposizione: optionsDisposizione[0],
    });
  };

  setCavi = () => {
    let caviTermoplastici = [],
      caviElastomerici = [],
      lsohDisabled = this.state.fotovoltaico;
    let { lsoh, tipoPosa } = this.state;
    let inter = tipoPosa !== 3;

    if (this.state.fotovoltaico) caviElastomerici = ["H1Z2Z2-K CPR"];
    else {
      switch (this.state.tipoConduttore) {
        case "Unipolare con guaina":
          caviElastomerici = [
            { nome: "FG16M16 0.6/1 KV", inter: true, lsoh: true },
            { nome: "FTG18M16 0.6/1 KV ", inter: true, lsoh: true },
            { nome: "FG16H2M16 0.6/1 KV", inter: true, lsoh: true },
            { nome: "ARG16M16 0.6/1 KV", inter: true, lsoh: true },
            { nome: "FG16R16 0.6/1 KV", inter: true, lsoh: false },
            { nome: "FG16H2R16 0.6/1 KV", inter: true, lsoh: false },
            { nome: "RG16R16 0.6/1 KV", inter: true, lsoh: false },
            { nome: "ARG16R16 0.6/1 KV", inter: true, lsoh: false },
            { nome: "H07RN-F", inter: false, lsoh: false },
          ]
            .filter((value) => {
              return (value.inter || inter) && value.lsoh === lsoh;
            })
            .map((a) => a.nome);
          break;
        case "Unipolare senza guaina":
          caviElastomerici = [
            { nome: "FG17-450/750V", inter: false, lsoh: true },
          ]
            .filter((value) => {
              return (value.inter || inter) && value.lsoh === lsoh;
            })
            .map((a) => a.nome);

          caviTermoplastici = [
            { nome: "H07Z1-K CPR", inter: false, lsoh: true },
            { nome: "FS17-450/750", inter: false, lsoh: false },
          ]
            .filter((value) => {
              return (value.inter || inter) && value.lsoh === lsoh;
            })
            .map((a) => a.nome);
          break;
        case "Multipolare":
          caviElastomerici = [
            { nome: "H07RN-F", inter: false, lsoh: true },
            { nome: "FG16OM16 – 0.6/1 KV", inter: true, lsoh: true },
            { nome: "ARG16R16 0.6/1 KV", inter: true, lsoh: true },
            { nome: "FTG18OM16 0.6/1 KV", inter: true, lsoh: true },
            { nome: "FG16OR16 0.6/1 KV", inter: true, lsoh: false },
            { nome: "RG16R16 0.6/1 KV", inter: true, lsoh: false },
            { nome: "FG16OH1R16 0.6/1 KV", inter: true, lsoh: false },
          ]
            .filter((value) => {
              return (value.inter || inter) && value.lsoh === lsoh;
            })
            .map((a) => a.nome);

          caviTermoplastici = [
            { nome: "FS18OR18 300/500V", inter: false, lsoh: false },
            { nome: "FS18OH2R18 300/500V", inter: false, lsoh: false },
          ]
            .filter((value) => {
              return (value.inter || inter) && value.lsoh === lsoh;
            })
            .map((a) => a.nome);
          break;
        default:
          return;
      }
    }

    let { materialeIsolante, tipoCavo } = this.state,
      cavi = [...caviElastomerici, ...caviTermoplastici];
    if (caviTermoplastici.length === 0)
      materialeIsolante = "Elastomerico (Gomma)";

    if (caviElastomerici.length === 0) materialeIsolante = "Termoplastico";

    if (!cavi.includes(tipoCavo) || cavi.length === 1) tipoCavo = cavi[0];

    if (materialeIsolante === "Elastomerico (Gomma)")
      tipoCavo = caviElastomerici[0];

    if (materialeIsolante === "Termoplastico") tipoCavo = caviTermoplastici[0];

    this.setState({
      caviElastomerici,
      caviTermoplastici,
      lsohDisabled,
      materialeIsolante,
      tipoCavo,
    });
  };

  setCei = () => {
    let ceiArgs, ceiImg;
    let tc = this.state.fotovoltaico
      ? "Fotovoltaico"
      : this.state.tipoConduttore;

    switch (this.state.posa) {
      case "Cavi in aria libera distanziati dalla parete/soffitto o su passerella":
        ceiArgs = ["13", "14", "15", "16", "17"];
        ceiImg = this.getCeiImg(2);
        break;
      case "Cavi in aria libera fissati alla parete/soffitto":
        ceiArgs = ["11", "11A", "52", "53"];
        ceiImg = this.getCeiImg(3);
        break;
      case "Cavi in aria libera a trifoglio":
        ceiArgs =
          tc === "Unipolare con guaina"
            ? ["11", "12", "21", "25", "43", "52", "53"]
            : ["12", "25"];
        ceiImg = this.getCeiImg(4);
        break;
      case "Cavi in aria libera in piano a contatto":
        ceiArgs =
          tc === "Unipolare con guaina"
            ? ["13", "14", "15", "16", "17"]
            : ["13", "14", "16"];
        ceiImg = this.getCeiImg(5);
        break;
      case "Cavi in aria libera distanziati su piano orizzontale":
        ceiArgs =
          tc === "Unipolare con guaina" ? ["14", "15", "16"] : ["14", "16"];
        ceiImg = this.getCeiImg(6);
        break;
      case "Cavi in aria libera distanziati su piano verticale":
        ceiArgs =
          tc === "Unipolare con guaina" ? ["14", "15", "16"] : ["14", "16"];
        ceiImg = this.getCeiImg(7);
        break;
      case "Cavi in tubo incassato in parete isolante":
        ceiArgs =
          tc === "Unipolare senza guaina"
            ? ["1", "51", "71", "73", "74"]
            : ["2", "51", "73", "74"];
        ceiImg = this.getCeiImg(
          tc === "Unipolare senza guaina"
            ? 8
            : tc === "Unipolare con guaina"
            ? 14
            : 0
        );
        break;
      case "Cavi in tubo in aria":
        ceiArgs =
          tc === "Unipolare senza guaina"
            ? [
                "3",
                "4",
                "5",
                "22",
                "23",
                "24",
                "31",
                "32",
                "33",
                "34",
                "41",
                "42",
                "72",
              ]
            : [
                "3A",
                "4A",
                "5A",
                "21",
                "22A",
                "25",
                "31",
                "32",
                "33A",
                "34A",
                "43",
              ];
        ceiImg = this.getCeiImg(
          tc === "Unipolare senza guaina"
            ? 9
            : tc === "Unipolare con guaina"
            ? 15
            : 1
        );
        break;
      case "Cavi in aria libera in posizione non accessibile":
        ceiArgs = ["18"];
        ceiImg = this.getCeiImg(tc === "Unipolare con guaina" ? 16 : 10);
        break;
      case "Cavi unipolari in tubi interrati a contatto":
        ceiArgs = [];
        ceiImg = this.getCeiImg(12);
        break;
      case "Cavi unipolari in tubo interrato":
        ceiArgs = ["61"];
        ceiImg = this.getCeiImg(13);
        break;
      case "Cavi multipolari in tubo interrato":
        ceiArgs = ["61"];
        ceiImg = this.getCeiImg(11);
        break;
      default:
        return;
    }

    this.setState({ tipoPosa: this.getTipoPosa(), ceiArgs, ceiImg });
  };

  getPopupText = (img) => {
    switch (img) {
      case "1":
        return "Cavi senza guaina in tubi protettivi circolari posati entro muri termicamente isolanti";
      case "2":
        return "Cavi multipolari in tubi protettivi circolari posati entro muri termicamente isolanti";
      case "3":
        return "Cavi senza guaina in tubi protettivi circolari posati su o distanziati da pareti";
      case "4":
        return "Cavi senza guaina in tubi protettivi non circolari posati su pareti";
      case "5":
        return "Cavi senza guaina in tubi protettivi annegati nella muratura";
      case "11":
        return "Cavi multipolari (o unipolari con guaina), con o senza armatura posati su o distanziati da pareti";
      case "12":
        return "Cavi multipolari (o unipolari con guaina), con o senza armatura su passerelle non perforate";
      case "13":
        return "Cavi multipolari (o unipolari con guaina), con o senza armatura su passerelle perforate";
      case "14":
        return "Cavi multipolari (o unipolari con guaina), con o senza armatura su mensole";
      case "15":
        return "Cavi multipolari (o unipolari con guaina), con o senza armatura fissati da collari";
      case "16":
        return "Cavi multipolari (o unipolari con guaina), con o senza armatura su passerelle a traversini";
      case "17":
        return "Cavi unipolari con guaina (o multipolari) sospesi a o incorporati in fili o corde di supporto";
      case "18":
        return "Conduttori nudi o cavi senza guaina su isolatori";
      case "21":
        return "Cavi multipolari (o unipolari con guaina) in cavità di strutture";
      case "22":
        return "Cavi unipolari senza guaina in tubi protettivi circolari posati in cavità di strutture";
      case "23":
        return " Cavi unipolari senza guaina in tubi protettivi non circolari posati in cavità di strutture";
      case "24":
        return " Cavi unipolari senza guaina in tubi protettivi non circolari annegati nella muratura";
      case "25":
        return "Cavi multipolari (o unipolari con guaina) posati in controsoffitti / pavimenti sopaelevati";
      case "31":
        return "Cavi senza guaina e cavi multipolari (o unipolari con guaina) in canali posati su parete su percorso orizzontale";
      case "32":
        return "Cavi senza guaina e cavi multipolari (o unipolari con guaina) in canali posati su parete su percorso verticale";
      case "33":
        return "Cavi senza guaina posati in canali incassati nel pavimento";
      case "34":
        return "Cavi senza guaina in canali sospesi";
      case "41":
        return "Cavi senza guaina in tubi protettivi circolari posati entro cunicoli chiusi, con percorso orizzontale o verticale ";
      case "42":
        return "Cavi senza guaina in tubi protettivi circolari posati entro cunicoli ventilati incassati nel pavimento";
      case "43":
        return "Cavi unipolari con guaina e multipolari posati in cunicoli aperti o ventilati con percorso orizzontale o verticale";
      case "51":
        return "Cavi multipolari (o cavi unipolari con guaina) posati direttamente entro pareti termicamente isolanti";
      case "52":
        return "Cavi multipolari (o cavi unipolari con guaina) posati direttamente nella muratura senza protezione meccanica addizionale";
      case "53":
        return "Cavi multipolari (o cavi unipolari con guaina) posati nella muratura con protezione meccanica addizionale";
      case "61":
        return "Cavi unipolari con guaina e multipolari in tubi protettivi interrati o in cunicoli interrati";
      case "71":
        return "Cavi senza guaina posati in elementi scanalati";
      case "72":
        return [
          "* circuiti per TV",
          <br />,
          "** circuiti per telecomunicazioni",
          <br />,
          "Cavi senza guaina posati in canali provvisti di elementi di separazione",
        ];
      case "73":
        return "Cavi senza guaina in tubi protettivi o cavi unipolari con guaina (o multipolari) posati in stipiti di porte";
      case "74":
        return "Cavi senza guaina in tubi protettivi o cavi unipolari con guaina (o multipolari) posati in stipiti di finestre";
      case "11A":
        return "Cavi multipolari (o unipolari con guaina), con o senza armatura fissati su soffitti";
      case "22A":
        return "Cavi multipolari (o unipolari con guaina) in tubi protettivi circolari posati in cavità di strutture";
      case "24A":
        return " Cavi multipolari  (o unipolari con guaina) in tubi protettivi non circolari annegati nella muratura";
      case "33A":
        return "Cavi multipolari posati in canali incassati nel pavimento";
      case "34A":
        return "Cavi multipolari (o unipolari con guaina) in canali sospesi";
      case "3A":
        return "Cavi multipolari in tubi protettivi circolari posati su o distanziati da pareti";
      case "4A":
        return "Cavi multipolari in tubi protettivi non circolari posati su pareti";
      case "5A":
        return "Cavi multipolari in tubi protettivi annegati nella muratura";
      default:
        return "Non esiste";
    }
  };

  getTipoPosa = () => {
    let { posa } = this.state;
    if (posa.includes("Cavi in tubo")) return 1;
    if (posa.includes("Cavi in aria libera")) return 2;
    if (posa.includes("interrat")) return 3;

    return 0;
  };

  checkProfondita = () => {
    let {
      profonditaPosa,
      numeroStrati,
      optionsProfondita1,
      optionsProfondita2,
      optionsProfondita3,
    } = this.state;

    optionsProfondita2 = optionsProfondita1.filter((value) => {
      return value > profonditaPosa[0];
    });

    if (numeroStrati >= 2 && optionsProfondita2.length === 0) numeroStrati = 1;
    else if (profonditaPosa[1] <= profonditaPosa[0])
      profonditaPosa[1] = optionsProfondita2[0];

    optionsProfondita3 = optionsProfondita2.filter((value) => {
      return value > profonditaPosa[1];
    });

    if (numeroStrati === 3 && optionsProfondita3.length === 0) numeroStrati = 2;
    else if (profonditaPosa[2] <= profonditaPosa[1])
      profonditaPosa[2] = optionsProfondita3[0];

    this.setState({
      profonditaPosa,
      numeroStrati,
      optionsProfondita1,
      optionsProfondita2,
      optionsProfondita3,
      profonditaPosaHidden: [numeroStrati === 1, numeroStrati < 3],
    });
  };

  popup = (img) => {
    this.setState(
      {
        popupImg: img,
        popupText: this.getPopupText(img),
      },
      () => this.setState({ popupProps: { visibility: "visible", opacity: 1 } })
    );
  };

  getIb = () => {
    var cosFi, senFi, circuitType, Pj, q, Pa, Ib, Vn;

    cosFi = this.state.fattorePotenza;
    Vn = this.state.tensioneEsercizio;
    senFi = Math.sqrt(1 - cosFi * cosFi);
    circuitType = this.state.circuito;

    switch (this.state.metodo) {
      case "Immissione diretta di Ib (A)":
        Ib = this.state.correnteEsercizio;
        if (circuitType === "Trifase in ca") {
          Pj = (Math.sqrt(3) * Vn * Ib * cosFi) / 1000;
          q = (Math.sqrt(3) * Vn * Ib * senFi) / 1000;
          Pa = (Math.sqrt(3) * Vn * Ib) / 1000;
        } else if (circuitType === "Monofase in ca") {
          Pj = (Vn * Ib * cosFi) / 1000;
          q = (Vn * Ib * senFi) / 1000;
          Pa = (Vn * Ib) / 1000;
        } //Continua
        else {
          Pj = (Vn * Ib) / 1000;
          q = 0;
          Pa = Pj;
        }

        this.setState({
          potenzaAttiva: Pj.toFixed(3),
          reattanza: q,
          potenzaApparente: Pa.toFixed(3),
        });
        break;
      case "Potenza attiva assorbita (KW)":
        Pj = this.state.potenzaAttiva;
        if (circuitType === "Trifase in ca") {
          Ib = (Pj * 1000) / (Math.sqrt(3) * Vn * cosFi);
          q = (Math.sqrt(3) * Vn * Ib * senFi) / 1000;
          Pa = (Math.sqrt(3) * Vn * Ib) / 1000;
        } else if (circuitType === "Monofase in ca") {
          Ib = (Pj * 1000) / (Vn * cosFi);
          q = (Vn * Ib * senFi) / 1000;
          Pa = (Vn * Ib) / 1000;
        } //Continua
        else {
          Ib = (Pj * 1000) / Vn;
          q = 0;
          Pa = Pj;
        }

        this.setState({
          correnteEsercizio: Ib.toFixed(3),
          reattanza: q,
          potenzaApparente: Number(Pa).toFixed(3),
        });
        break;
      default:
        Pa = this.state.potenzaApparente;
        if (circuitType === "Trifase in ca") {
          Ib = (Pa * 1000) / (Math.sqrt(3) * Vn);
          Pj = (Math.sqrt(3) * Vn * Ib * cosFi) / 1000;
          q = (Math.sqrt(3) * Vn * Ib * senFi) / 1000;
        } else if (circuitType === "Monofase in ca") {
          Ib = (Pa * 1000) / Vn;
          Pj = (Vn * Ib * cosFi) / 1000;
          q = (Vn * Ib * senFi) / 1000;
        } //Continua
        else {
          Ib = (Pa * 1000) / Vn;
          Pj = Pa;
          q = 0;
        }

        this.setState({
          correnteEsercizio: Ib.toFixed(3),
          potenzaAttiva: Number(Pj).toFixed(3),
          reattanza: q,
        });
    }
  };

  changeStep = (step) => {
    let stepName;
    // let blank = `       `;
    switch (step) {
      case 1:
        stepName = `Parametri${this.bk}Impianto`;
        break;
      case 2:
        // if (window.matchMedia("(min-width: 800px)").matches)
        stepName = `Corrente${this.bk}Conduttore${this.bk}e${this.bk}Posa`;
        break;
      case 3:
        this.checkProfonditaPosaHidden(String(this.state.numeroStrati));
        this.onNumeroStratiChange();
        stepName = `Disposizione${this.bk}Conduttori`;
        break;
      case 4:
        stepName = `Scelta${this.bk}Cavo`;
        this.setCavi();
        this.forceUpdate(() => {
          let cavi =
            this.state.materialeIsolante === "Elastomerico (Gomma)"
              ? this.state.caviElastomerici
              : this.state.caviTermoplastici;
          if (cavi.length === 0)
            this.setState({ lsoh: !this.state.lsoh }, this.setCavi);
        });
        break;
      case 5:
        stepName = "Riepilogo";
        break;
      default:
        stepName = "";
    }

    this.defaults.step = step;
    this.defaults.stepName = stepName;

    this.setState(
      {
        step,
        stepName,
      },
      () => {
        this.data.normalizedSection = 1.5;
        var elmnt = document.getElementById(
          [
            "denominazione",
            "metodo",
            "conduttori-parallelo",
            "materiale-isolante",
            "report",
          ][step - 1]
        );

        elmnt.scrollIntoView();
        this.getIb();
      }
    );
  };

  checkProfonditaPosaHidden = (value) => {
    let profonditaPosaHidden = [true, true];
    let { optionsProfondita2, optionsProfondita3 } = this.state;
    let val = parseInt(value);

    if (val > 1)
      if (optionsProfondita2.length > 0) profonditaPosaHidden[0] = false;
      else val = 1;

    if (val > 2)
      if (optionsProfondita3.length > 0) profonditaPosaHidden[1] = false;
      else val = 2;

    this.setState({ numeroStrati: val, profonditaPosaHidden });
  };

  getStep3 = () => {
    switch (this.state.tipoPosa) {
      case 1: // in tubo
        return (
          <div>
            <FormItem
              text="Sezioni presumibilmente simili?"
              inputType="switch"
              checked={this.state.sezioniSimili}
              hidden={this.state.stessoMaterialeIsolanteHidden}
              handleChange={(checked) =>
                this.setState({ sezioniSimili: checked })
              }
            />
          </div>
        );
      case 2: // aria libera
        return (
          <div>
            <FormItem
              text="Sezioni presumibilmente simili?"
              inputType="switch"
              checked={this.state.sezioniSimili}
              hidden={this.state.stessoMaterialeIsolanteHidden}
              handleChange={(checked) =>
                this.setState({ sezioniSimili: checked })
              }
            />

            <FormItem
              text="Numero di strati"
              inputType="slider"
              handleChange={(value) =>
                this.setState(
                  { numeroStrati: value },
                  this.onNumeroStratiChange
                )
              }
              value={this.state.numeroStrati}
              min={1}
              max={3}
              disabled={false}
            />

            <FormItem
              text="Disposizione"
              inputType="select"
              handleChange={(value) => this.setState({ disposizione: value })}
              value={this.state.disposizione}
              options={this.state.optionsDisposizione}
              fill={true}
            />
          </div>
        );
      case 3: // interrati
        return (
          <div>
            <FormItem
              text="Numero circuiti nello stesso fascio"
              inputType="slider"
              min={1}
              max={10}
              value={this.state.numeroCircuitiStessoFascio}
              handleChange={(value) =>
                this.setState({ numeroCircuitiStessoFascio: value })
              }
              disabled={false}
            />

            <FormItem
              text="Numero di strati"
              inputType="slider"
              handleChange={(value) => this.checkProfonditaPosaHidden(value)}
              value={this.state.numeroStrati}
              min={1}
              max={3}
              disabled={false}
            />

            <FormItem
              text="Resistività termica del terreno"
              inputType="select"
              value={this.state.resistivitaTerreno}
              handleChange={(value) =>
                this.setState({ resistivitaTerreno: value })
              }
              options={[1, 1.2, 1.5, 2, 2.5]}
            />

            <FormItem
              text="Profondità di Posa I:"
              inputType="select"
              value={this.state.profonditaPosa[0]}
              options={this.state.optionsProfondita1}
              handleChange={(value) =>
                this.setState(
                  {
                    profonditaPosa: [
                      parseFloat(value),
                      this.state.profonditaPosa[1],
                      this.state.profonditaPosa[2],
                    ],
                  },
                  this.checkProfondita
                )
              }
            />

            <FormItem
              text="Profondità di Posa II:"
              inputType="select"
              value={this.state.profonditaPosa[1]}
              options={this.state.optionsProfondita2}
              handleChange={(value) =>
                this.setState(
                  {
                    profonditaPosa: [
                      this.state.profonditaPosa[0],
                      parseFloat(value),
                      this.state.profonditaPosa[2],
                    ],
                  },
                  this.checkProfondita
                )
              }
              hidden={this.state.profonditaPosaHidden[0]}
            />

            <FormItem
              text="Profondità di Posa III:"
              inputType="select"
              value={this.state.profonditaPosa[2]}
              options={this.state.optionsProfondita3}
              handleChange={(value) =>
                this.setState(
                  {
                    profonditaPosa: [
                      this.state.profonditaPosa[0],
                      this.state.profonditaPosa[1],
                      parseFloat(value),
                    ],
                  },
                  this.checkProfondita
                )
              }
              hidden={this.state.profonditaPosaHidden[1]}
            />

            <FormItem
              text="Distanza tra i circuiti"
              inputType="select"
              value={this.state.distanzaCircuiti}
              options={[0, 0.25, 0.5, 1]}
              handleChange={(value) =>
                this.setState({ distanzaCircuiti: parseFloat(value) })
              }
            />
          </div>
        );
      default:
        return <div />;
    }
  };

  getComponentsByStep = (step) => {
    switch (step) {
      case 1:
        return (
          <div>
            <FormItem
              id="denominazione"
              text="Denominazione Impianto"
              inputType="text"
              value={this.state.nome}
              handleChange={(value) => this.setState({ nome: value })}
            ></FormItem>

            <FormItem
              text="Impianto Fotovoltaico"
              inputType="switch"
              handleChange={this.onFotovoltaicoChange}
              checked={this.state.fotovoltaico}
            ></FormItem>

            <FormItem
              text="Tipo di Circuito"
              inputType="select"
              options={this.state.optionsCircuito}
              value={this.state.circuito}
              handleChange={(value) =>
                this.setState({ circuito: value }, this.onCircuitoChange)
              }
            ></FormItem>

            <FormItem
              text="Tensione di Esercizio (V)"
              inputType="number"
              value={this.state.tensioneEsercizio}
              handleChange={(value) => {
                this.setState({ tensioneEsercizio: parseInt(value) });
              }}
            ></FormItem>

            <FormItem
              text="Fattore di Potenza"
              inputType="number"
              value={this.state.fattorePotenza}
              step="0.1"
              min="0.1"
              disabled={this.state.fattorePotenzaDisabled}
              handleChange={(value) => {
                this.setState({ fattorePotenza: value });
              }}
            ></FormItem>

            <FormItem
              text="Stato del Neutro"
              inputType="select"
              options={this.state.optionsStatoNeutro}
              value={this.state.neutro}
              handleChange={(value) => {
                this.setState({ neutro: value });
              }}
              hidden={this.state.neutroDisabled}
            ></FormItem>

            <FormItem
              text="Frequenza di rete (Hz)"
              inputType="select"
              value={this.state.frequenzaRete}
              options={[50, 60]}
              handleChange={(value) =>
                this.setState({ frequenzaRete: parseInt(value) })
              }
              hidden={this.state.frequenzaDisabled}
            ></FormItem>

            <FormItem
              text="Lunghezza impianto (m)"
              inputType="number"
              step="10"
              min="10"
              value={this.state.lunghezzaImpianto}
              handleChange={(value) => {
                this.setState({ lunghezzaImpianto: value });
              }}
            ></FormItem>

            <FormItem
              text="Temperatura ambiente (°C)"
              inputType="number"
              step="5"
              min={this.state.temperaturaMin}
              value={this.state.temperaturaAmbiente}
              handleChange={(value) => {
                this.setState({ temperaturaAmbiente: Number(value) });
              }}
            ></FormItem>

            <FormItem
              text="Tempo di intervento delle protezioni (s)"
              inputType="number"
              step="0.1"
              value={this.state.tempoIntervento}
              handleChange={(value) => {
                this.setState({ tempoIntervento: value });
              }}
              min="0.1"
            ></FormItem>

            <FormItem
              text="Massima caduta di tensione percentuale"
              inputType="number"
              step="1"
              value={this.state.massimaCadutaTensione}
              min="1"
              max="99"
              handleChange={(value) => {
                this.setState({ massimaCadutaTensione: value });
              }}
            />
          </div>
        );
      case 2:
        return (
          <div>
            <FormItem
              id="metodo"
              text="Metodo da seguire"
              inputType="select"
              options={[
                "Potenza attiva assorbita (KW)",
                "Immissione diretta di Ib (A)",
                "Potenza apparente assorbita (KVA)",
              ]}
              value={this.state.metodo}
              handleChange={(value) => {
                this.setState({ metodo: value }, this.onMetodoChange);
              }}
            />

            <FormItem
              text="Potenza Assorbita (KW)"
              inputType="number"
              hidden={this.state.potenzaAttivaHidden}
              value={this.state.potenzaAttiva}
              digits={3}
              min={1}
              step={1}
              handleChange={(value) => {
                this.setState({ potenzaAttiva: value }, this.getIb);
              }}
            />

            <FormItem
              text="Potenza Apparente (KW)"
              inputType="number"
              hidden={this.state.potenzaApparenteHidden}
              value={this.state.potenzaApparente}
              digits={3}
              min={1}
              step="any"
              handleChange={(value) => {
                this.setState({ potenzaApparente: value }, this.getIb);
              }}
            />

            <FormItem
              text="Corrente di Esercizio Ib (A)"
              inputType="number"
              disabled={this.state.correnteEsercizioDisabled}
              value={this.state.correnteEsercizio}
              digits={3}
              min={0.1}
              step={0.1}
              handleChange={(value) => {
                this.setState({ correnteEsercizio: value }, this.getIb);
              }}
            />

            <hr
              style={{
                color: "black",
                paddingTop: "5px",
                paddingBottom: "5px",
                width: "100%",
                height: "1px",
                border: "none",
              }}
            />

            <FormItem
              text="Tipo di conduttore"
              disabled={this.state.fotovoltaico}
              inputType="select"
              options={[
                "Unipolare senza guaina",
                "Unipolare con guaina",
                "Multipolare",
              ]}
              value={this.state.tipoConduttore}
              handleChange={(value) => {
                this.setState(
                  { tipoConduttore: value },
                  this.onTipoConduttoreChange
                );
              }}
            />

            <FormItem
              text="Posa"
              inputType="select"
              value={this.state.posa}
              options={this.state.optionsPosa}
              handleChange={(value) => {
                this.setState({ posa: value }, this.setCei);
              }}
              fill={true}
            />

            <div className="div-rif-cei form-item">
              <label className="lbl-rif-cei">{"RIFERIMENTO CEI 64-8"}</label>

              <CeiTable args={this.state.ceiArgs} onClick={this.popup} />

              <div className="placing-scheme">
                <div className="framework">
                  <img
                    src={this.state.ceiImg}
                    id="placing-scheme"
                    alt=""
                    loading="eager"
                  />
                </div>
              </div>
            </div>

            <CeiPopup
              img={this.state.popupImg}
              text={this.state.popupText}
              popupProps={this.state.popupProps}
              resetProps={() =>
                this.setState({
                  popupProps: { visibility: "hidden", opacity: 0 },
                })
              }
            />
          </div>
        );
      case 3:
        return (
          <div>
            <FormItem
              id="conduttori-parallelo"
              text="Numero conduttori in parallelo"
              inputType="slider"
              min={1}
              max={9}
              value={this.state.conduttoriParallelo}
              disabled={false}
              handleChange={(value) => {
                let circuitiStessoStrato = Math.max(
                  this.state.circuitiStessoStrato,
                  value
                );
                let stessoMaterialeIsolanteHidden = circuitiStessoStrato === 1;
                this.setState({
                  conduttoriParallelo: value,
                  circuitiStessoStrato,
                  stessoMaterialeIsolanteHidden,
                });
              }}
            />

            <FormItem
              text="Numero di circuiti sullo stesso strato"
              inputType="slider"
              min={this.state.conduttoriParallelo}
              max={9}
              value={this.state.circuitiStessoStrato}
              disabled={false}
              handleChange={(value) => {
                let conduttoriParallelo = Math.min(
                  value,
                  this.state.conduttoriParallelo
                );
                let stessoMaterialeIsolanteHidden = value === 1;
                this.setState({
                  circuitiStessoStrato: value,
                  stessoMaterialeIsolanteHidden,
                  conduttoriParallelo,
                });
              }}
            />

            <FormItem
              text="Stesso materiale isolante?"
              inputType="switch"
              checked={this.state.stessoMaterialeIsolante}
              hidden={this.state.stessoMaterialeIsolanteHidden}
              handleChange={(checked) =>
                this.setState({ stessoMaterialeIsolante: checked })
              }
            />
            {this.getStep3()}
          </div>
        );
      case 4:
        return (
          <div>
            <FormItem
              id="materiale-isolante"
              text="Materiale isolante"
              inputType="select"
              options={
                this.state.caviTermoplastici.length > 0
                  ? this.state.caviElastomerici.length > 0
                    ? ["Elastomerico (Gomma)", "Termoplastico"]
                    : ["Termoplastico"]
                  : ["Elastomerico (Gomma)"]
              }
              value={this.state.materialeIsolante}
              handleChange={(value) =>
                this.setState({ materialeIsolante: value }, this.setCavi)
              }
            />

            <div
              style={{
                verticalAlign: "middle",
                background: "#f4f4f4",
                padding: "10px",
                borderBottom: "1px #ccc dotted",
                textAlign: "left",
                height: "132px",
                width: "100%",
                flexFlow: "row wrap",
              }}
            >
              <img
                className="lsoh-img"
                src="./images/lsoh.png"
                loading="eager"
                style={{
                  marginTop: "8px",
                  border: "2px solid grey",
                  borderRadius: "5px",
                }}
                alt=""
              />
              <div
                style={{
                  display: "flex",
                  width: "40%",
                  height: "100%",
                  float: "right",
                }}
              >
                <label className="form-item">{"Cavo L.S.O.H."}</label>

                <Toggle
                  checked={this.state.lsoh}
                  handleChange={(value) =>
                    this.setState({ lsoh: value }, this.setCavi)
                  }
                  disabled={this.state.lsohDisabled}
                  noFloat={true}
                />
              </div>
            </div>

            <FormItem
              text="Tipo di cavo"
              inputType="select"
              value={this.state.tipoCavo}
              handleChange={(value) => this.setState({ tipoCavo: value })}
              options={
                this.state.materialeIsolante === "Elastomerico (Gomma)"
                  ? this.state.caviElastomerici
                  : this.state.caviTermoplastici
              }
            />

            <div
              style={{
                display: "flex",
                verticalAlign: "middle",
                background: "#f4f4f4",
                padding: "10px",
                textAlign: "left",
                height: "70px",
                width: "100%",
                flexFlow: "row wrap",
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                className="schede-prodotti"
                onClick={() => {
                  window.open(
                    "http://www.generalcavi.com/index.php?action=prodotti"
                  );
                }}
              >
                {"Schede prodotti"}
              </button>
            </div>

            <div
              style={{
                display: "flex",
                verticalAlign: "middle",
                background: "#f4f4f4",
                padding: "10px",
                borderBottom: "1px #ccc dotted",
                textAlign: "left",
                width: "100%",
                flexFlow: "row wrap",
                justifyContent: "center",
              }}
            >
              <img
                src="./images/logo-general-cavi.png"
                alt="General Cavi"
                loading="eager"
              />
            </div>
          </div>
        );
      case 5:
        const report =
          this.data.normalizedSection !== 0
            ? this.calcReport(this.state.sezioneConduttore)
            : null;

        return (
          <div id="report" className="form-item" style={{ paddingTop: "1px" }}>
            <Report items={report} />

            <div
              id="div-ricalcola form-item"
              className="form-item"
              style={{
                display: "flex",
                position: "relative",
                padding: "10px",
                textAlign: "left",
                height: "70px",
                opacity: "100%",
                zIndex: "1",
                width: "100%",
                flexFlow: "row wrap",
                borderTop: "1px #ccc dotted",
                borderBottom: "1px #ccc dotted",
              }}
            >
              <label className="form-item">
                {"Sezione del Conduttore (mm²)"}
              </label>
              <Select
                handleChange={(value) =>
                  this.setState({
                    sezioneConduttore: parseFloat(value),
                    recalculating: true,
                  })
                }
                value={this.state.sezioneConduttore}
                options={[
                  1.5, 2.5, 4, 6, 10, 16, 25, 35, 50, 70, 95, 120, 150, 185,
                  240,
                ].filter((value) => {
                  return value >= this.data.minimumSection;
                })}
              />
            </div>
          </div>
        );

      default:
        return <div></div>;
    }
  };

  componentDidMount() {
    // gestione gestures

    let form = document.getElementById("form");
    form.addEventListener(
      "touchstart",
      (e) => {
        var cn = e.target.className;

        if (e.targetTouches.length > 1 || cn.includes("slider"))
          this.startPoint = null;
        else this.startPoint = e.targetTouches[0].clientX;
      },
      false
    );

    form.addEventListener(
      "touchend",
      (e) => {
        if (this.startPoint === null) return;

        this.endPoint = e.changedTouches[0].clientX;

        if (this.startPoint - this.endPoint < -100) {
          // swipe verso destra
          if (this.state.step > 1) this.changeStep(this.state.step - 1);
        }

        if (this.startPoint - this.endPoint > 100) {
          // swipe verso sinistra
          if (this.state.step < 5) this.changeStep(this.state.step + 1);
        }
      },
      false
    );
  }

  curtainHover = (targetid, hovered) => {
    let target = document.getElementById(targetid);
    switch (target.id) {
      case "curtain-home":
        target.src = "./images/" + (hovered ? "home-c" : "home-w") + ".png";
        break;
      case "curtain-fb":
        target.src =
          "./images/" + (hovered ? "facebook-c" : "facebook-w") + ".png";
        break;
      case "curtain-yt":
        target.src =
          "./images/" + (hovered ? "youtube-c" : "youtube-w") + ".png";
        break;
      case "curtain-save":
        target.src = "./images/" + (hovered ? "save-c" : "save-w") + ".png";
        break;
      case "curtain-import":
        target.src = "./images/" + (hovered ? "import-c" : "import-w") + ".png";
        break;
      case "curtain-info":
        target.src = "./images/" + (hovered ? "info-c" : "info-w") + ".png";
        break;
      default:
        return;
    }
  };

  render() {
    return (
      <div
        id="container"
        className="container"
        style={{
          margin: "auto",
          maxWidth: "800px",
          height: window.innerHeight,
        }}
      >
        <header id="header">
          <button
            className="curtain"
            type="button"
            onClick={() => {
              document.getElementById("myNav").style.width = "100%";
              document.getElementById("nav-content").style.width = "66%";
            }}
          >
            &#8801;
          </button>
          <pre>{this.state.stepName}</pre>
        </header>

        {/* Menu a tendina */}
        <div
          id="myNav"
          className="overlay"
          onClick={(e) => {
            if (e.target.id === "myNav") {
              document.getElementById("nav-content").style.width = "0";
              document.getElementById("myNav").style.width = "0%";
            }
          }}
        >
          <div
            id="nav-content"
            className="overlay-content"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <div
              className="menu-item"
              onClick={this.home}
              onMouseEnter={(e) => {
                this.curtainHover("curtain-home", true);
              }}
              onMouseOut={(e) => {
                this.curtainHover("curtain-home", false);
              }}
            >
              <img
                className="curtain-btn"
                id="curtain-home"
                loading="eager"
                alt="Home"
                src="./images/home-w.png"
              />
              <label>Homepage</label>
            </div>

            <div
              className="menu-item"
              onClick={this.facebook}
              onMouseEnter={(e) => {
                this.curtainHover("curtain-fb", true);
              }}
              onMouseOut={(e) => {
                this.curtainHover("curtain-fb", false);
              }}
            >
              <img
                className="curtain-btn"
                id="curtain-fb"
                loading="eager"
                alt="Facebook"
                src="./images/facebook-w.png"
              />
              <label>Facebook</label>
            </div>

            <div
              className="menu-item"
              onClick={this.youtube}
              onMouseEnter={(e) => {
                this.curtainHover("curtain-yt", true);
              }}
              onMouseOut={(e) => {
                this.curtainHover("curtain-yt", false);
              }}
            >
              <img
                className="curtain-btn"
                id="curtain-yt"
                loading="eager"
                alt="YouTube"
                src="./images/youtube-w.png"
              />
              <label>YouTube</label>
            </div>

            <div
              className="menu-item"
              onClick={() => {
                document.getElementById("nav-content").style.width = "0";
                document.getElementById("myNav").style.width = "0%";
                this.save();
              }}
              onMouseEnter={(e) => {
                this.curtainHover("curtain-save", true);
              }}
              onMouseOut={(e) => {
                this.curtainHover("curtain-save", false);
              }}
            >
              <img
                className="curtain-btn"
                id="curtain-save"
                loading="eager"
                alt="Save"
                src="./images/save-w.png"
              />
              <label>Salva</label>
            </div>

            <div
              className="menu-item"
              onClick={() => {
                document.getElementById("nav-content").style.width = "0";
                document.getElementById("myNav").style.width = "0%";
                this.import();
              }}
              onMouseEnter={(e) => {
                this.curtainHover("curtain-import", true);
              }}
              onMouseOut={(e) => {
                this.curtainHover("curtain-import", false);
              }}
            >
              <img
                className="curtain-btn"
                id="curtain-import"
                loading="eager"
                alt="Import"
                src="./images/import-w.png"
              />
              <label>Importa progetto</label>
            </div>

            <div
              className="menu-item"
              onClick={() => {
                document.getElementById("nav-content").style.width = "0";
                document.getElementById("myNav").style.width = "0%";
                this.info();
              }}
              onMouseEnter={(e) => {
                this.curtainHover("curtain-info", true);
              }}
              onMouseOut={(e) => {
                this.curtainHover("curtain-info", false);
              }}
            >
              <img
                className="curtain-btn"
                id="curtain-info"
                loading="eager"
                alt="Info"
                src="./images/info-w.png"
              />
              <label>Informazioni</label>
            </div>

            <label className="mobile-footer">
              <pre>
                {`Cables Project 2022 v 1.4\n© General Cavi Spa - All Rights Reserved\nVia dell'Industria 22 48017 - Lavezzola (RA)\nP.I.: 01208310399`}
              </pre>
            </label>
          </div>
        </div>

        <img id="logo" alt="Logo" src="images\CP-logo.png" />

        {/* Menu desktop */}
        <div className="menu">
          <img
            id="btn-home"
            src="./images/home-w.png"
            className="menu-btn"
            loading="eager"
            alt="Home Page"
            onClick={this.home}
            onMouseEnter={(e) => {
              e.target.src = "./images/home-c.png";
            }}
            onMouseOut={(e) => {
              e.target.src = "./images/home-w.png";
            }}
          />

          <img
            className="menu-btn"
            loading="eager"
            alt="Facebook"
            src="./images/facebook-w.png"
            onClick={this.facebook}
            onMouseEnter={(e) => {
              e.target.src = "./images/facebook-c.png";
            }}
            onMouseOut={(e) => {
              e.target.src = "./images/facebook-w.png";
            }}
          />

          <img
            className="menu-btn"
            loading="eager"
            alt="YouTube"
            src="./images/youtube-w.png"
            onClick={this.youtube}
            onMouseEnter={(e) => {
              e.target.src = "./images/youtube-c.png";
            }}
            onMouseOut={(e) => {
              e.target.src = "./images/youtube-w.png";
            }}
          />

          <img
            className="menu-btn"
            loading="eager"
            alt="Salva Progetto"
            src="./images/save-w.png"
            onClick={this.save}
            onMouseEnter={(e) => {
              e.target.src = "./images/save-c.png";
            }}
            onMouseOut={(e) => {
              e.target.src = "./images/save-w.png";
            }}
          />

          <img
            className="menu-btn"
            loading="eager"
            alt="Importa progetto"
            src="./images/import-w.png"
            onClick={this.import}
            onMouseEnter={(e) => {
              e.target.src = "./images/import-c.png";
            }}
            onMouseOut={(e) => {
              e.target.src = "./images/import-w.png";
            }}
          />

          <img
            className="menu-btn"
            loading="eager"
            alt="Info"
            src="./images/info-w.png"
            onClick={this.info}
            onMouseEnter={(e) => {
              e.target.src = "./images/info-c.png";
            }}
            onMouseOut={(e) => {
              e.target.src = "./images/info-w.png";
            }}
          />
        </div>

        {/* Contenuto principale */}
        <div className="content" id="form">
          <form>{this.getComponentsByStep(this.state.step)}</form>
        </div>

        {/* Copyright */}
        <div className="copyright">
          <label className="mobile-footer">
            <pre>
              {`Cables Project 2022 v 1.4\n© General Cavi Spa - All Rights Reserved\nVia dell'Industria 22 48017 - Lavezzola (RA)\nP.I.: 01208310399`}
            </pre>
          </label>
        </div>

        {/* Info */}
        <Info
          popupProps={this.state.infoProps}
          resetProps={() =>
            this.setState({ infoProps: { visibility: "hidden", opacity: 0 } })
          }
        />

        <footer>
          <NavigationGroup
            page={this.state.step}
            changeStep={this.changeStep}
            refresh={() => {
              this.resetDefaults(this.state.step);
            }}
            new={this.resetDefaults}
            pdf={() => {
              let doc = this.getReportPDF();
              if (
                /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
                  navigator.userAgent.toLowerCase()
                )
              ) {
                window.open(
                  doc.output("bloburl", {
                    filename: `CP-riepilogo-${this.state.nome}.pdf`,
                  })
                );
              } else {
                doc.save(`CP-riepilogo-${this.state.nome}.pdf`);
              }
            }}
          />
        </footer>
      </div>
    );
  }
}
